import React from 'react';
import PropTypes from 'prop-types';

import StoreCard from './store-card';

import '../styles/store-card-list.scss';

const StoreCardList = ({stores = [], activeStore, onStoreClick}) => {
  return stores && stores.length ? (
    <ul data-testid="store-card-list" className="store-card-list">
      {stores.map((store) => {
        return (
          <StoreCard key={store.id} store={store} onClick={onStoreClick} active={`store-${activeStore}` === store.id} />
        );
      })}
    </ul>
  ) : null;
};

StoreCardList.propTypes = {
  stores: PropTypes.array,
  activeStore: PropTypes.string,
  onStoreClick: PropTypes.func,
};

export default StoreCardList;
